/**
 * Display modes for search results visualization
 */
export enum SearchDisplayMode {
  GRID = "grid",
  MAP = "map",
  AI = "ai",
  PROPERTY = "property",
}
